import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';
import { SyncItemLogsTableSkeletonComponent } from '../sync-item-logs-table-skeleton/sync-item-logs-table-skeleton.component';

@Component({
  selector: 'app-sync-item-logs-skeleton',
  templateUrl: './sync-item-logs-skeleton.component.html',
  styleUrls: ['./sync-item-logs-skeleton.component.scss'],
  imports: [SkeletonComponent, SyncItemLogsTableSkeletonComponent],
})
export class SyncItemLogsSkeletonComponent {
  readonly summaryStats = [1, 2, 3, 4, 5, 6];
}